import { render, staticRenderFns } from "./room.vue?vue&type=template&id=7030392a&scoped=true&"
import script from "./room.vue?vue&type=script&lang=js&"
export * from "./room.vue?vue&type=script&lang=js&"
import style0 from "./room.vue?vue&type=style&index=0&id=7030392a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7030392a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\linlin\\resbdadjustsourcehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7030392a')) {
      api.createRecord('7030392a', component.options)
    } else {
      api.reload('7030392a', component.options)
    }
    module.hot.accept("./room.vue?vue&type=template&id=7030392a&scoped=true&", function () {
      api.rerender('7030392a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/room.vue"
export default component.exports